import React from 'react';

import cn from 'classnames';

import { useFilterTags } from '@features/JournalEventsFilters/lib/useFilterTags';
import { Chip, Icon } from '@shared/ui';

import cls from './FilterTags.module.css';

export const FilterTags = () => {
    const {
        dateFromQueryValue,
        dateToQueryValue,
        searchQueryValue,
        isClearValuesBtn,
        onClearAllValues,
        dateRangeQueryValue,
        onDateClick,
        onEstimateClick,
        onAuthorClick,
        onTypeClick,
        setSearchQueryState,
        typesData,
        estimatesData,
        authorsData,
        t,
    } = useFilterTags();
    return (
        <div className={cn(cls.FilterTagsList)}>
            {searchQueryValue?.length > 0 && (
                <Chip
                    textContent={`“${searchQueryValue}”`}
                    onClick={() => setSearchQueryState(null)}
                    endIcon={<Icon iconName="cross" width={8} height={8} />}
                    color={cls.search}
                />
            )}

            {dateFromQueryValue && dateToQueryValue && (
                <Chip
                    textContent={dateRangeQueryValue}
                    endIcon={<Icon iconName="cross" width={8} height={8} />}
                    color={cls.date}
                    onClick={onDateClick}
                />
            )}

            {authorsData
                ?.filter((item) => item.isChecked)
                ?.map((author) => (
                    <Chip
                        key={author.value}
                        textContent={author.label}
                        endIcon={<Icon iconName="cross" width={8} height={8} />}
                        color={cls.author}
                        onClick={() => onAuthorClick(String(author.value))}
                    />
                ))}
            {typesData
                ?.filter((item) => item.isChecked)
                ?.map((type) => (
                    <Chip
                        key={type.value}
                        textContent={type.label}
                        endIcon={<Icon iconName="cross" width={8} height={8} />}
                        color={cls.type}
                        onClick={() => onTypeClick(String(type.value))}
                    />
                ))}
            {estimatesData
                ?.filter((item) => item.isChecked)
                ?.map((est) => (
                    <Chip
                        key={est.value}
                        textContent={est.label}
                        endIcon={<Icon iconName="cross" width={8} height={8} />}
                        color={cls.estimate}
                        onClick={() => onEstimateClick(String(est.value))}
                    />
                ))}

            {isClearValuesBtn && (
                <Chip
                    textContent={t('JournalEvents.EmptyEventsPlaceholder.NotFound.ResetFiltersBtn')}
                    containerStyles={cls.clearChip}
                    startIcon={<Icon iconName="paintbrush" width={14} height={14} />}
                    color={cls.clear}
                    onClick={onClearAllValues}
                />
            )}
        </div>
    );
};
